import { ASBV } from 'api/query/asbv/asbv';
import { SearchSort } from 'api/query/search/search-sort';
import { useCallback } from 'react';
import { DisplayFormat } from 'shared/display-format.enum';
import { ResultsAction } from './results-action';
import { useResultsContext } from './results-context';

/**
 * Allows access to the results state along with helper functions to dispatch updates.
 */
export const useResults = () => {
  const { state, dispatch } = useResultsContext();

  const setCustomASBVs = useCallback((asbvs: ASBV[]) => dispatch({
    type: ResultsAction.SetCustomASBVs,
    payload: asbvs,
  }), [dispatch]);

  const setDisplay = useCallback((display: string) => dispatch({
    type: ResultsAction.SetDisplay,
    payload: display as DisplayFormat,
  }), [dispatch]);

  const setTopPercentile = useCallback((percentile: number) => dispatch({
    type: ResultsAction.SetTopPercentile,
    payload: percentile,
  }), [dispatch]);

  const setBottomPercentile = useCallback((percentile: number) => dispatch({
    type: ResultsAction.SetBottomPercentile,
    payload: percentile,
  }), [dispatch]);

  const setSortByASBV = useCallback((sort: SearchSort) => dispatch({
    type: ResultsAction.SetSortByASBV,
    payload: sort,
  }), [dispatch]);

  return {
    customASBVs: state.customASBVs,
    display: state.display,
    topPercentile: state.topPercentile,
    bottomPercentile: state.bottomPercentile,
    sortByASBV: state.sortByASBV,
    setCustomASBVs,
    setDisplay,
    setTopPercentile,
    setBottomPercentile,
    setSortByASBV,
  };
};
